<template>
	<div class="container-fluid border-top" v-show="numInCart > 0">
		<div class="row mt-2">
			<div class="col-12 h3">
				Kosár tartalma:
			</div>
		</div>
		<div
			class=""
			v-for="(item,index) in inCart"
			:key="`cart-${index}`"
		>
			<cartitem
				:item="item"
				:index="index"
			/>
		</div>
		<div class="row d-flex justify-content-center">
			<div class="col-12 h5">
				Összesítés:
				{{numInCart}} db termék {{cartSum}} Ft összegben
			</div>
			<div class="col-6">
				<button class="btn btn-outline-danger btn-lg m-2" @click.prevent="removeCart">
					Kosár ürítése
				</button>
			</div>
			<div class="col-6">
				<router-link
					class="btn btn-outline-success btn-lg m-2"
					:to="'/orders/ordersum'"
				>
					Véglegesítés
					<i class="fa fa-chevron-right"></i>
				</router-link>
			</div>
		</div>
	</div>
</template>
<script>
import cartitem from './cart_item.vue'
import {mapGetters,mapActions} from 'vuex'
export default {
	name: 'cart',
	components: {
		cartitem
	},
	computed: {
		...mapGetters(['inCart','cartSum']),
		numInCart() {
			return this.inCart.reduce((total, current) => total + ~~current.db, 0)
		}
	},
	methods: {
		...mapActions(['removeCart','removeFromCart','addToCart','rFromCart','pToCart'])
	}
}
</script>


// WEBPACK FOOTER //
// src/components/cart/cart.vue